module.exports = __webpack_public_path__ + "static/media/gift.b2a47fdf.svg";